export function getContainerDimensions() {
  const { innerHeight, innerWidth } = window;
  const widthToHeightRadio = innerWidth / innerHeight;
  const originalWidthToHeightRatio = (1920 * 2) / (1080 * 2);
  if (originalWidthToHeightRatio > widthToHeightRadio) {
    // width-constrained; i.e. L & R touch && T & B don't touch
    return {
      width: innerWidth,
      height: innerWidth / originalWidthToHeightRatio,
    };
  }
  if (originalWidthToHeightRatio < widthToHeightRadio) {
    // height-constrained; i.e. L & R don't touch && T & B touch
    return {
      width: innerHeight * originalWidthToHeightRatio,
      height: innerHeight,
    };
  }
  return {
    width: innerWidth,
    height: innerHeight,
  };
}
